import { create } from 'zustand';
import { FrameworkReportingExecution } from '../types';
import { PaginationMetadata } from '../../../API/types';

interface FrameworkReportsState {
    filterFrameworks: string[];
    filterTypes: string[];
    filterAccounts: string[];
    filterCsms: string[];
    filterFromDate: Date | null;
    filterToDate: Date | null;
    dateOption: string;
    page: number;
    isLoading: boolean;
    paginationMetadata: PaginationMetadata;
    frameworkReportExecutions: FrameworkReportingExecution[];
    setFilterFrameworks: (frameworks: string[]) => void;
    setFilterTypes: (types: string[]) => void;
    setFilterAccounts: (accounts: string[]) => void;
    setFilterCsms: (csms: string[]) => void;
    setFilterFromDate: (date: Date | null) => void;
    setFilterToDate: (date: Date | null) => void;
    setDateOption: (option: string) => void;
    setPage: (page: number) => void;
    refetch: VoidFunction;
    resetFilters: () => void;
    setIsLoading: (isLoading: boolean) => void;
    setFrameworkReportExecutions: (executions: FrameworkReportingExecution[], paginationMetadata: PaginationMetadata) => unknown;
    setRefetch: (refetch: VoidFunction) => void;
}

export type FrameworkReportsStore = ReturnType<typeof createStore>;

type CreateStoreArgs = {
    filterFrameworks: string[];
    filterTypes: string[];
    filterAccounts: string[];
    filterCsms: string[]
    filterFromDate: Date | null;
    filterToDate: Date | null;
    dateOption: string;
    page: number;
    isLoading: boolean;
    isFetching: boolean;
};

export const createStore = (args: CreateStoreArgs) => {
    return create<FrameworkReportsState>((set) => {
        return {
            filterFrameworks: args.filterFrameworks,
            filterTypes: args.filterTypes,
            filterAccounts: args.filterAccounts,
            filterCsms: args.filterCsms,
            filterFromDate: args.filterFromDate,
            filterToDate: args.filterToDate,
            dateOption: args.dateOption,
            page: args.page,
            isLoading: args.isLoading,
            isFetching: args.isFetching,
            frameworkReportExecutions: [],
            paginationMetadata: {
                itemsPerPage: 10,
                page: 1,
                totalItems: 0,
                totalPages: 0,
            },
            setFilterFrameworks: (frameworks) => set({ filterFrameworks: frameworks }),
            setFilterTypes: (types) => set({ filterTypes: types }),
            setFilterAccounts: (accounts) => set({ filterAccounts: accounts }),
            setFilterCsms: (csms) => set({ filterCsms: csms }),
            setFilterFromDate: (date) => set({ filterFromDate: date }),
            setFilterToDate: (date) => set({ filterToDate: date }),
            setDateOption: (option) => set({ dateOption: option }),
            setPage: (page) => set({ page: page }),
            setIsLoading: (isLoading) => set({ isLoading: isLoading }),
            refetch: () => Promise.resolve(),
            resetFilters: () => set({ filterFrameworks: [], filterTypes: [], filterAccounts: [], filterCsms: [], filterFromDate: null, filterToDate: null, dateOption: '120d', page: 1 }),
            setFrameworkReportExecutions: (executions, paginationMetadata) => set({ frameworkReportExecutions: executions, paginationMetadata: paginationMetadata }),
            setRefetch: (refetch) => set({ refetch: refetch }),
        };
    });
};
